export const settings = {
  setShareTitle: 'Share App',
  setNotifiationsTitle: 'Notifications',
  setContactAppOwnerTitle: 'Contact App Owner',
  setContactDevelopersTitle: 'Contact Developers',
  setReportAppTitle: 'Report Application',
  setDeleteAccountTitle: 'Delete Account',
  setLogOutTitle: 'Log Out',
  setShareAppCurtainTitle: 'Share App',
  setShareAppCurtainButtonTitle: 'Copy link',
  setShareAppAlertWhenAppLinkWasCopied: 'Link copied!',
  setNotificationsInAppTitle: 'In-App',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Chats',
  setNotificationsDiscussionsTitle: 'Discussions',
  setNotificationsNewsTitle: 'News Feed',
  setNotificationsEventsTitle: 'Events',
  setNotificationsAdminTitle: 'Admin messages',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Push notifications are off',
  setNotificationsPushOffText: 'To enable pushes, please, go to your device’s settings and enable notifications',
  setReportAppFlagCurtainTitle: 'Flag',
  setAppReportedCurtainContent: 'Content reported',
  setDeleteCurtainTitle: 'Delete Account',
  setDeleteCurtainInputContent: 'Password',
  setDeleteCurtainCancelButtonTitle: 'Cancel',
  setDeleteCurtainConfirmButtonTitle: 'Confirm',
  setDeleteCurtainIncorrectPasswordAlertText: 'Password is incorrect',
  setTurnNotificationsOnText: 'To turn them on, please, click button below and allow receiving notifications.',
  setTurnNotificationsOnButton: 'Turn on push notifications',
  changeLanguage: 'Change app language',
  changeLanguageAlertSuccess: 'App language has been changed successfully'
}
